import { TranslationKeys } from './en';

export const fi: TranslationKeys = {
  // Common
  common: {
    loading: 'Ladataan...',
    error: 'Virhe',
    cancel: 'Peruuta',
    save: 'Tallenna',
    continue: 'Jatka',
    back: 'Takaisin',
    close: 'Sulje',
    select: 'Valitse',
    required: 'Pakollinen',
    appTitle: 'Fire and Ice',
    goBack: 'Palaa takaisin',
    goHome: 'Etusivulle',
    success: 'Onnistui',
    inTallinn: 'Tallinnassa',
  },

  // Page Titles
  pageTitles: {
    home: 'Uuden aikakauden wellness-studio',
    book: 'Varaa aika',
    pricing: 'Hinnoittelu',
    promotions: 'Kampanjat',
    contact: 'Ota yhteyttä',
    checkBalance: 'Tarkista lahjakortin saldo',
    gallery: 'Galleria',
  },

  invitation: {
    accept: 'Hyväksy kutsu',
    decline: 'Hylkää kutsu',
    accepted: 'Kutsu hyväksytty! Tilisi on nyt yhdistetty.',
    declined: 'Kutsu hylätty.',
    processing: 'Käsitellään vastaustasi...',
    error: 'Tämä kutsu on virheellinen, vanhentunut tai tilit on jo yhdistetty.',
  },

  // Navigation
  nav: {
    title: 'Fire & Ice',
    home: 'Etusivu',
    bookSession: 'Varaa aika',
    myAccount: 'Oma tili',
    login: 'Kirjaudu',
    logout: 'Kirjaudu ulos',
    signUp: 'Rekisteröidy',
    giftCards: 'Lahjakortit',
    sessionBundles: 'Käyntikokonaisuudet ja tilaukset',
    services: 'Palvelut',
    packages: 'Paketit',
    scienceStudies: 'Tiede',
    sessionBundlesShort: 'Käyntikokonaisuudet',
    pricing: 'Hinnoittelu',
    memberships: 'Jäsenyydet',
    promotions: 'Kampanjat',
    about: 'Ota yhteyttä',
    gallery: 'Galleria',
  },

  promotions: 'Kampanjat',

  about: {
    title: 'Ota yhteyttä',
    description:
      'Tervetuloa Fire & Ice -keskukseen. Olemme omistautuneet terveytesi ja elinvoimasi optimointiin kontrastihoidon ja palautumispalvelujen avulla.',
    contactInfo: 'Yhteystiedot',
    addressLabel: 'Osoite',
    emailLabel: 'Sähköposti',
    phoneLabel: 'Puhelin',
    howToFindUs: 'Kuinka löydät meidät',
    directions: 'Sijaitsemme osoitteessa Hobujaama 4. Etsi sisäänkäynti pääkäytävän vierestä.',
  },

  // Hero Section
  hero: {
    title: 'Elinvoimaa Elämään',
    subtitle: 'Fire and Ice — innovatiivinen wellness-studio, joka auttaa sinua…',
    benefit1: 'Suoriutumaan Paremmin',
    benefit2: 'Voimaan Paremmin',
    benefit3: 'Työskentelemään Paremmin',
    benefit4: 'Nukkumaan Paremmin',
    benefit5: 'Elämään Paremmin',
  },

  services: 'Palvelut',
  learnMore: 'Lue lisää',
  ourServices: 'Meidän Palvelut',
  ourPackages: 'Tutustu pakettiimme',
  packageIncludes: 'Paketti sisältää:',
  bookPackage: 'Varaa paketti',
  min: 'min',

  // Auth
  auth: {
    logout: 'Kirjaudu ulos',
    accountDeactivated: 'Tili deaktivoitu',
    accountDeactivatedMessage:
      'Tilisi on deaktivoitu. Ota yhteyttä asiakaspalveluun saadaksesi apua.',
  },

  // Session Bundles Page
  sessionBundles: {
    title: 'Paketit ja jäsenyydet',
    subtitle: 'Valitse täydellinen paketti hyvinvointimatkallesi',
    loadingSessionBundles: 'Ladataan käyntikokonaisuuksia...',
    loadError: 'Käyntikokonaisuuksien lataus epäonnistui. Yritä myöhemmin uudelleen.',
    purchase: 'Osta',
    subscribe: 'Tilaa',
    per: 'per',
    monthlySubscriptions: 'Kuukausitilaukset',
    monthlySubscriptionsSpouse: 'Kuukausitilaukset puolison alennuksella',
    bulkSessionBundles: 'Käyntikokonaisuudet (kertaosto)',
    bulkSessionBundlesSpouse: 'Käyntikokonaisuudet puolison alennuksella',
    showSpousePricing: 'Näytä puolisohinta',
    spouseDisclaimer:
      '* Puolisohinta on saatavilla linkitetyille tileille. Oikeutus vahvistetaan kirjautumisen yhteydessä.',
    sessionBundleTypeMonthly: 'Kuukausittain',
    spouseOffer: 'Puolison tarjous',
    discountOff: '{{percentage}}% alennus',
    discountOffForMonths: '{{percentage}}% alennus {{months}} kuukaudeksi',
    perSession: 'per istunto',
  },

  // Pricing Page
  pricing: {
    title: 'Hinnoittelu',
    subtitle: 'Valitse täydellinen paketti hyvinvointimatkallesi',
    membership: 'Jäsenyys',
    sessionBundle: 'Käyntikokonaisuus',
    package: 'Paketti',
    pack: 'Pakata',
    packs: 'Pakkaukset',
    visitsPerMonth: 'Käynnit/kk',
    sessions: 'Istunnot',
    regularPrice: 'Normaalihinta',
    price: 'Hinta',
    openingDeal: 'Avaustarjous (-{{percentage}}%)',
    openingDealSessionBundle: 'Avaustarjous (-{{percentage}}%)',
    pricePerSession: 'Hinta/istunto',
    notes: 'Huomautukset',
  },

  // Booking Page
  booking: {
    title: 'Varaa aika',
    selectService: 'Valitse palvelu',
    selectDateTime: 'Valitse päivä ja aika',
    loadingServices: 'Ladataan palveluita...',
    loadError: 'Palveluiden lataus epäonnistui. Yritä myöhemmin uudelleen.',
    duration: 'Kesto',
    minutes: 'minuuttia',
    noAvailableSlots: 'Ei vapaita aikoja',
    selectTime: 'Valitse Aika',
    confirmBooking: 'Vahvista varaus',
    bookingDetails: 'Varauksen tiedot',
    service: 'Palvelu',
    date: 'Päivä',
    time: 'Aika',
    confirmButton: 'Vahvista varaus',
    processing: 'Käsitellään...',
    success: 'Varaus vahvistettu onnistuneesti!',
    error: 'Varauksen vahvistus epäonnistui. Yritä uudelleen.',
    step1: 'Vaihe 1/3: Valitse palvelu',
    step2: 'Vaihe 2/3: Valitse päivä ja aika',
    step3: 'Vaihe 3/3: Vahvista varaus',
    selectDate: 'Valitse päivä',
    loadingAvailableTimes: 'Ladataan vapaita aikoja...',
    noAvailableTimesForDate: 'Ei vapaita aikoja tälle päivälle',
    confirmYourBooking: 'Vahvista varauksesi',
    confirmYourDetails: 'Vaihe 3/3: Vahvista tietosi',
    serviceLabel: 'Palvelu:',
    dateLabel: 'Päivä:',
    timeLabel: 'Aika:',
    durationLabel: 'Kesto:',
    totalLabel: 'Yhteensä:',
    contactInformation: 'Yhteystiedot',
    phoneNumberRequired: 'Puhelinnumero vaaditaan varauksen vahvistamiseksi',
    phoneNumberInvalid: 'Syötä kelvollinen puhelinnumero',
    phoneNumberTooShortEst: 'Viron puhelinnumeroissa on oltava vähintään 7 numeroa',
    phoneNumberTooLongEst: 'Viron puhelinnumeroissa voi olla enintään 8 numeroa',
    phoneNumberTooShort: 'Puhelinnumero on liian lyhyt',
    phoneNumberTooLong: 'Puhelinnumero on liian pitkä',
    confirming: 'Vahvistetaan...',
    bookingFailed: 'Varauksen tekeminen epäonnistui. Yritä uudelleen.',
    step2ChooseDateTime: 'Vaihe 2/3: Valitse päivä ja aika',
    bookAllSessions:
      'Varaathan kaikki pakettiin sisältyvät hoidot. Hoitokerrat voivat tapahtua eri päivinä.',
    rescheduleTitle: 'Siirrä varaus',
    rescheduleSubtitle: 'Valitse uusi päivä ja aika varauksellesi',
    currentBooking: 'Nykyinen varaus',
    confirmReschedule: 'Vahvista siirto',
    reschedulingSuccess: 'Varauksesi on siirretty onnistuneesti!',
    reschedulingError: 'Varauksen siirto epäonnistui. Yritä uudelleen.',
    participantsLabel: 'Osallistujat',
    enterGiftCardCode: 'Syötä lahjakortin koodi',
    invalidGiftCardCode: 'Virheellinen lahjakortin koodi',
    giftCardError: 'Virhe lahjakortin käytössä',
    giftCardRedemptionFailed: 'Lahjakortin lunastus epäonnistui. Yritä uudelleen.',
    giftCard: 'Lahjakortti',
    applying: 'Käytetään...',
    apply: 'Käytä',
    fullyCoveredByGiftCard: 'Varauksesi on kokonaan katettu lahjakortilla!',
    noPaymentRequired: 'Lisämaksua ei tarvita.',
    balance: 'Saldo',
    remainingBalance: 'Jäljellä oleva saldo',
    remove: 'Poista',
    priceLabel: 'Hinta:',
    confirmAndPay: 'Vahvista ja maksa',
    nameRequired: 'Nimi on pakollinen',
    emailRequired: 'Sähköposti on pakollinen',
    emailInvalid: 'Virheellinen sähköpostiosoite',
    enterYourName: 'Syötä nimesi',
    enterYourEmail: 'Syötä sähköpostisi',
    guestBookingSuccess: 'Varaus vahvistettu! Saat vahvistusviestin sähköpostiisi.',
    bulkBookingSuccess: '{{count}} varausta luotu onnistuneesti!',
    bulkBookingSuccessTitle: 'Varaukset vahvistettu onnistuneesti!',
    bookAnotherSession: 'Varaa uudelleen',
    chooseHowToProceed: 'Valitse, miten haluat jatkaa varaustasi:',
    continueAsGuest: 'Jatka vieraana',
    loginToBook: 'Kirjaudu sisään tai Rekisteröidy, jos sinulla on tili',
    paymentOption: 'Maksutapa',
    isMixedCart:
      'Et voi yhdistää eri palvelu- ja pakettimaksutapoja samassa kassalla. Sekalaiset ostoskorit voi maksaa vain kortilla tai paikan päällä.',
    remainingSessions: 'Jäljellä olevat käynnit',
    subscriptions: 'Tilaukset',
    sessionBundles: 'Käyntikokonaisuudet',
    payByCard: 'Maksa kortilla',
    payAtSite: 'Maksa paikan päällä',
    paymentMethods: 'Maksutavat',
    infoSavedNote: 'Tiedot tallennettu tulevia varauksia varten',
    unavailableTitle: 'Ei saatavilla olevat tilaukset ja paketit',
    unavailableMessage: 'Nämä tilaukset ja paketit ovat vanhentuneet tai täysin käytetty.',
    sessionsRemaining: 'Jäljellä olevat käynnit',
    status: 'Tila',
    expired: 'Vanhentunut',
    insufficientCredits:
      'Sinulla on {{available}} käyntiä käytettävissä, mutta yrität varata {{required}} käyntiä.',
    insufficientCreditsActionStart: 'Ole hyvä ja ',
    insufficientCreditsActionModify: 'muokkaa varaustasi',
    insufficientCreditsActionMiddle: ' tai ',
    insufficientCreditsActionPurchase: 'osta lisäpaketti',
    insufficientCreditsActionEnd: '.',
  },

  // Account Page
  account: {
    title: 'Oma tili',
    personalInfo: 'Henkilötiedot',
    email: 'Sähköposti',
    name: 'Nimi',
    phoneNumber: 'Puhelinnumero',
    gender: 'Sukupuoli',
    birthday: 'Syntymäpäivä',
    upcomingBookings: 'Tulevat varaukset',
    pastBookings: 'Menneet varaukset',
    cancelledBookings: 'Peruutetut varaukset',
    noBookings: 'Ei varauksia',
    cancelBooking: 'Peruuta',
    cancelBookingConfirmTitle: 'Peruuta tämä varaus?',
    cancelBookingConfirmMessage:
      'Haluatko varmasti peruuttaa varauksen: {{serviceName}} {{date}} klo {{time}}?',
    cancelBookingYes: 'Kyllä, peruuta varaus',
    cancelBookingNo: 'Pidä varaus',
    confirm: 'Vahvista',
    rescheduleBooking: 'Siirrä',
    profile: 'Profiili',
    mySessionBundle: 'Käyntikokonaisuuteni',
    mySessionBundlesAndSubscriptions: 'Omat istuntopaketit, tilaukset ja paketit',
    bookings: 'Varaukset',
    notProvided: 'Ei annettu',
    edit: 'Muokkaa',
    save: 'Tallenna',
    cancel: 'Peruuta',
    sessionsLeft: 'Käyntejä jäljellä',
    expires: 'Vanhenee',
    activeSessionBundles: 'Aktiiviset käyntikokonaisuudet',
    viewAllBookings: 'Näytä kaikki varaukset',
    spouseDiscount: 'Puolison alennus',
    spouseDiscountDesc:
      'Syötä puolisosi sähköpostiosoite myöntääksesi heille pääsy alennettuihin paketteihin.',
    sendInvite: 'Lähetä kutsu',
    spouse: {
      title: 'Puolison tili',
      linked: 'Tilisi on yhdistetty: {{email}}',
      pending: 'Kutsu odottaa vastausta: {{email}}',
      declined:
        'Aiempi kutsusi osoitteeseen {{email}} hylättiin. Voit syöttää uuden sähköpostiosoitteen tai saman yrittääksesi uudelleen.',
      invite: 'Syötä puolisosi sähköpostiosoite lähettääksesi yhdistämiskutsun.',
    },
    manageSubscription: 'Hallinnoi tilausta',
    sessionsRemaining: 'Käyntejä jäljellä',
    sessionsUsed: 'Käytetyt/varatut käynnit',
    renewalDate: 'Uusimispäivä',
    activeSubscription: 'Aktiivinen tilaus',
    renewsOn: 'Uusiutuu',
    loadingBookings: 'Ladataan varauksia...',
    noBookingsYet: 'Ei vielä varauksia. Varaa ensimmäinen käyntisi!',
    minutes: 'minuuttia',
    phoneNumberUpdated: 'Puhelinnumero päivitetty onnistuneesti!',
    preferencesUpdated: 'Asetukset päivitetty onnistuneesti!',
    promoOptIn: 'Haluan vastaanottaa kampanjaviestejä ja uutiskirjeitä.',
    invitationSent: 'Kutsu lähetetty onnistuneesti!',
    welcomeMessage:
      'Kiitos rekisteröitymisestäsi Fire & Ice -keskukseen! Olemme innoissamme toivottaessamme sinut osaksi hyvinvointiyhteisöämme. Tutustu tiliisi ja löydä kaikki upeat palvelumme.',
    // Booking cancellation
    bookingCancelledSuccess: 'Varaus peruutettu onnistuneesti!',
    bookingCancelFailed: 'Varauksen peruutus epäonnistui. Yritä uudelleen.',
    cancellationPolicy24Hours: 'Varauksia ei voi peruuttaa 24 tunnin sisällä käynnin ajankohdasta.',
    reschedulingPolicy24Hours: 'Varauksia ei voi siirtää 24 tunnin sisällä käynnin ajankohdasta.',
    cannotCancel24Hours: 'Ei voi peruuttaa',
    cannotReschedule24Hours: 'Ei voi siirtää',
    cancellationPolicyNotice:
      'Huomio: Varauksia ei voi peruuttaa 24 tunnin sisällä käynnin ajankohdasta.',
    // Phone number validation errors
    phoneNumberTooShortEst: 'Viron puhelinnumeroissa on oltava vähintään 7 numeroa',
    phoneNumberTooLongEst: 'Viron puhelinnumeroissa voi olla enintään 8 numeroa',
    phoneNumberTooShort: 'Puhelinnumero on liian lyhyt',
    phoneNumberTooLong: 'Puhelinnumero on liian pitkä',
    phoneNumberInvalid: 'Syötä kelvollinen puhelinnumero',
    unusedSessionsNote: 'Käyttämättömät käyntisi siirtyvät eteenpäin jopa 3 kuukaudeksi.',
    confirmed: 'vahvistettu',
    cancelled: 'peruutettu',
    at: 'klo',
    sessionsRolledOver: 'Siirretty',
    expiresOn: 'Vanhenee',
    bookAgain: 'Varaa uudelleen',
    filterAll: 'Kaikki',
    filterUpcoming: 'Tulevat',
    filterPast: 'Menneet',
    filterCancelled: 'Peruutetut',
    searchBookings: 'Etsi varauksia...',
    noUpcomingBookings: 'Ei tulevia varauksia',
    readyToBook: 'Valmiina varaamaan seuraavan hyvinvointikäyntisi?',
    noPastBookings: 'Ei menneitä varauksia',
    bookingHistoryWillAppear: 'Varaushistoriasi ilmestyy tänne',
    noCancelledBookings: 'Ei peruutettuja varauksia',
    cancelledBookingsWillAppear: 'Peruutetut varaukset ilmestyvät tänne',
    bookYourFirstSession: 'Varaa ensimmäinen käyntisi',
    participants: 'osallistujaa',
    loadingSessionBundles: 'Ladataan käyntikokonaisuuksia...',
    noActiveSessionBundles: 'Ei aktiivisia käyntikokonaisuuksia',
    myPackagePacks: 'Pakettipakkaukseni',
    noActivePackagePacks: 'Ei aktiivisia pakettipakkauksia',
    packsRemaining: 'Pakkauksia jäljellä',
    packsUsed: 'Käytetyt pakkaukset',
    usedPackagePacksTitle: 'Käytetyt pakettipakkaukset',
    // Subscription management
    mySubscription: 'Tilaukseni',
    subscription: 'Tilaus',
    cancelSubscription: 'Peru tilaus',
    cancelConfirmTitle: 'Peru tilaus?',
    cancelConfirmMessage: 'Oletko varma, että haluat perua? Etusi jatkuvat {{endDate}} asti.',
    cancelSuccess: 'Tilauksesi on peruutettu ja päättyy {{endDate}}.',
    cancelError: 'Tilauksen peruminen epäonnistui. Ota yhteyttä tukeen.',
    subscriptionExpires: 'Tilauksesi on aktiivinen ja päättyy {{endDate}}.',
    subscriptionRenews: 'Tilauksesi uusiutuu {{endDate}}.',
    keep: 'Säilytä tilaus',
    noActiveSubscription: 'Ei aktiivisia tilauksia',
    nameRequired: 'Nimi on pakollinen',
    nameUpdated: 'Nimi päivitetty onnistuneesti',
    emailInvalid: 'Anna kelvollinen sähköpostiosoite',
    emailUpdateInitiated:
      'Vahvistus vaaditaan. Tarkista uusi sähköpostiosoitteesi vahvistuslinkin saamiseksi.',
    emailChangeSubmitted:
      'Lähetimme vahvistuslinkin uuteen sähköpostiosoitteeseesi. Vahvista muutos napsauttamalla linkkia kyseisessä sähköpostissa.',
    expiredSectionTitle: 'Vanhentuneet tilaukset ja käytetyt paketit',
    subscriptionExpiredOn: 'Vanhentunut',
    sessionBundleFullyUsed: 'Käyntikokonaisuus täysin käytetty',
    notificationPreferences: 'Ilmoitusasetukset',
    receiveEmailReminders: 'Vastaanota varausmuistutukset sähköpostitse',
    receiveSmsReminders: 'Vastaanota varausmuistutukset tekstiviestillä',
    noPhoneNumber: 'Ei puhelinnumeroa',
    addPhoneToEnable: 'Lisää puhelin ottaaksesi käyttöön',
    session: 'Istunto',
  },

  // Email Verification
  verifyEmail: {
    title: 'Sähköpostin vahvistus',
    verifying: 'Vahvistetaan sähköpostiosoitettasi...',
    success: 'Sähköpostiosoitteesi on päivitetty onnistuneesti!',
    errorTitle: 'Vahvistus epäonnistui',
    noToken: 'Vahvistustunnusta ei löytynyt.',
    genericError: 'Tapahtui virhe.',
    backToAccount: 'Siirry tililleni',
    redirecting: 'Sinut ohjataan profiiliisi 3 sekunnin kuluttua...',
    clickHereToReturn:
      'Jos sinua ei ohjata automaattisesti, napsauta tästä palataksesi profiiliisi.',
  },

  // Email Templates
  email: {
    verification: {
      subject: 'Vahvista uusi sähköpostiosoitteesi - Fire & Ice',
      heading: 'Vahvista uusi sähköpostiosoitteesi',
      body: 'Pyysit äskettäin Fire & Ice -tilisi sähköpostiosoitteen muuttamista. Vahvista muutos napsauttamalla alla olevaa painiketta. Linkki on voimassa 1 tunnin.',
      button: 'Vahvista uusi sähköpostiosoite',
      disclaimer:
        'Jos et pyytänyt tätä sähköpostiosoitteen muutosta, voit huoletta jättää tämän viestin huomiotta.',
    },
    bookingConfirmation: {
      subject: 'Fire & Ice -varauksesi vahvistus',
      heading: 'Varaus vahvistettu!',
      greeting: 'Hei',
      bodyIntro: 'Kiitos varauksestasi. Tässä ovat tulevan istuntosi tiedot:',
      bookingListHeader: 'Varauksesi',
      payAtSiteLabel: 'Studiolla maksettava summa',
    },
    bookingReminder: {
      subject: 'Muistutus: Fire & Ice -varauksesi huomenna',
      heading: '⏰ Varausmuistutus',
      greeting: 'Hei',
      bodyIntro: 'Tämä on ystävällinen muistutus, että sinulla on varaus huomenna.',
      closingMessage: 'Odotamme näkevämme sinut!',
      footerMessage: 'Tämä on automaattinen muistutus tulevasta varauksestasi.',
    },
    dailyReminder: {
      subject: 'Muistutus: Fire & Ice -varauksesi tänään',
      heading: 'Fire & Ice varausmuistutus',
      greeting: 'Hei',
      greetingSingle: 'Sinulla on tapaaminen tänään:',
      greetingMultiple: 'Sinulla on {{count}} tapaamista tänään:',
      closingMessage: 'Odotamme näkevämme sinut!',
      footerMessage: 'Tämä on automaattinen muistutus tulevasta varauksestasi/varauksistasi.',
    },
    purchaseConfirmation: {
      subject: 'Fire & Ice -ostosi vahvistus',
      heading: 'Osto vahvistettu!',
      bodyIntroSessionBundle:
        'Kiitos ostoksestasi! Uusi käyntikokonaisuutesi on aktiivinen ja käyttövalmis.',
      bodyIntroSubscription: 'Kiitos ostoksestasi! Uusi tilauksesi on aktiivinen ja käyttövalmis.',
      detailsLabel: 'Oston tiedot:',
      priceLabel: 'Maksettu summa:',
      sessionBundleInfo:
        'Olet ostanut {{sessions}} istuntoa. Istuntojen käyttöön ei ole aikarajaa - ne eivät vanhene koskaan!',
      subscriptionInfo:
        'Tilauksesi uusiutuu automaattisesti {{renewalDate}}. Käyttämättömät istunnot siirtyvät eteenpäin enintään 3 kuukaudeksi. Voit peruuttaa tilauksesi milloin tahansa tilisi osiosta Fire & Ice -verkkosivustolla.',
      ctaHeading: 'Valmis aloittamaan?',
      ctaBody:
        'Tutustu hyvinvointipalveluihimme ja varaa ensimmäinen istuntosi jo tänään. Odotamme sinua Fire & Iceen!',
      ctaButton: 'Varaa ensimmäinen istuntosi',
    },
    rescheduleConfirmation: {
      subject: 'Fire & Ice -varauksesi on siirretty',
      heading: 'Varaus siirretty',
      bodyIntro: 'Varauksesi seuraavalle palvelulle on siirretty onnistuneesti:',
      serviceLabel: 'Palvelu:',
      oldBookingHeading: 'Edellinen aika',
      newBookingHeading: 'Uusi aika',
      dateLabel: 'Päivämäärä:',
      timeLabel: 'Aika:',
    },
    cancellationConfirmation: {
      subject: 'Fire & Ice -varauksesi on peruutettu',
      heading: 'Varaus peruutettu',
      bodyIntro: 'Varauksesi seuraavalle palvelulle on peruutettu onnistuneesti:',
      bookingDetails: 'Peruutetun varauksen tiedot:',
      serviceLabel: 'Palvelu:',
      dateLabel: 'Päivämäärä:',
      timeLabel: 'Aika:',
      refundNoticeSessionBundle: 'Istuntoluotto on palautettu aktiiviseen käyntikokonaisuuteen.',
      refundNoticeSubscription: 'Istuntoluotto on palautettu aktiiviseen tilaukseesi.',
      refundNoticePaid: 'Varauksesi maksettiin kortilla eikä sitä voi palauttaa.',
      refundNoticeDefault: 'Varauksesi on peruutettu.',
    },
    spouseInvite: {
      subject: 'Puolison tilin kutsu - Fire & Ice',
      heading: 'Sinut on kutsuttu!',
      body: 'kutsui sinut linkittämään Fire & Ice -tilisi puolisoksi.',
      acceptButton: 'Hyväksy kutsu',
      declineButton: 'Hylkää',
    },
    spouseResponse: {
      subject: 'Puolison tilin vastaus - Fire & Ice',
      heading: 'Kutsun vastaus',
      bodyAccepted: 'hyväksyi puolison tilin kutsusi!',
      bodyDeclined: 'hylkäsi puolison tilin kutsusi.',
    },
    footer: {
      company: 'Fire and Ice',
      address: 'Hobujaama tn 4, Tallinn',
      emailSentTo: 'Tämä viesti lähetettiin osoitteeseen',
      reason: 'Sait tämän viestin, koska rekisteröidyit Fire & Ice -palveluun.',
    },
  },

  // Complete Registration
  registration: {
    title: 'Viimeistele rekisteröintisi',
    subtitle: 'Anna seuraavat tiedot viimeistelläksesi tilisi luomisen',
    firstName: 'Etunimi',
    lastName: 'Sukunimi',
    phoneNumber: 'Puhelinnumero',
    phoneNumberPlaceholder: 'esim. +358 50 123 4567',
    submit: 'Viimeistele rekisteröinti',
    submitting: 'Lähetetään...',
    success: 'Rekisteröinti valmis!',
    error: 'Rekisteröinnin viimeistely epäonnistui. Yritä uudelleen.',
    oneLastStep: 'Viimeinen vaihe...',
    welcome: 'Tervetuloa Fire & Ice -keskukseen',
    reviewTerms: 'Tarkista ja hyväksy alla olevat ehdot viimeistelläksesi rekisteröintisi.',
    agreeToTerms: 'Hyväksyn',
    termsOfService: 'käyttöehdot',
    promoOptIn: 'Haluan vastaanottaa kampanjaviestejä ja uutiskirjeitä.',
    agreeToEmails: 'Haluan vastaanottaa markkinointisähköposteja',
    completeSignUp: 'Viimeistele rekisteröinti',
    completing: 'Viimeistellään...',
    mustAgreeToTerms: 'Sinun on hyväksyttävä käyttöehdot jatkaaksesi.',
    errorOccurred: 'Tapahtui virhe. Yritä uudelleen.',
    nameLabel: 'Koko nimi',
    namePlaceholder: 'Syötä koko nimesi',
    nameRequired: 'Anna nimesi.',
    gender: 'Sukupuoli',
    genderPlaceholder: 'Valitse sukupuolesi',
    male: 'Mies',
    female: 'Nainen',
    birthday: 'Syntymäpäivä',
    birthdayPlaceholder: 'Valitse syntymäpäiväsi',
    birthdayInFuture: 'Syntymäpäivä ei voi olla tulevaisuudessa',
  },

  // Error messages
  errors: {
    unauthorized: 'Sinun täytyy kirjautua käyttääksesi tätä sivua',
    notFound: 'Sivua ei löytynyt',
    general: 'Jotain meni vikaan. Yritä uudelleen.',
    // Auth callback errors
    authenticationError: 'Todennusvirhe',
    authenticationErrorMessage: 'Kohtasimme virheen todennuksen aikana. Sinut ohjataan etusivulle.',
    authError: 'Virhe: {{message}}',
    redirecting: 'Ohjataan...',
    authenticating: 'Todennetaan...',
    loading: 'Ladataan...',
    missingCallbackParams: 'Puuttuvat vaaditut takaisinsoittoparametrit',
    // Auth0 configuration errors
    auth0ConfigMissing:
      'Auth0-konfiguraatio puuttuu. Tarkista REACT_APP_AUTH0_DOMAIN ja REACT_APP_AUTH0_CLIENT_ID ympäristömuuttujat.',
    auth0ConfigError: 'Auth0-konfiguraatiovirhe. Tarkista konsoli lisätiedoista.',
    confirmationFailed: 'Vahvistus epäonnistui. ',
    paymentNotSucceeded: 'Maksu ei onnistunut.',

    // API Error Codes
    api: {
      AUTH_TOKEN_MISSING: 'Todennus vaaditaan. Kirjaudu sisään.',
      AUTH_TOKEN_INVALID: 'Istuntosi on vanhentunut. Kirjaudu uudelleen sisään.',
      AUTH_UNAUTHORIZED: 'Sinulla ei ole oikeuksia suorittaa tätä toimintoa.',

      BOOKING_NOT_FOUND: 'Varausta ei löytynyt.',
      BOOKING_CANNOT_CANCEL: 'Varausta ei voi peruuttaa 24 tunnin kuluessa tapaamisen ajasta.',
      BOOKING_ALREADY_CANCELLED: 'Tämä varaus on jo peruutettu.',
      BOOKING_SLOT_UNAVAILABLE: 'Tämä aikavälä ei ole enää saatavilla.',
      BOOKING_INVALID_DATA: 'Virheelliset varaustiedot.',
      BOOKING_REQUIRED_FIELDS_MISSING: 'Vaaditut varaustiedot puuttuvat.',
      BOOKING_BULK_PARTIAL_FAILURE: 'Joitakin varauksia ei voitu suorittaa.',
      BOOKING_BULK_COMPLETE_FAILURE: 'Varausten suorittaminen epäonnistui.',

      PAYMENT_REQUIRED: 'Tämän varauksen suorittaminen vaatii maksun.',
      PAYMENT_FAILED: 'Maksu epäonnistui. Yritä uudelleen.',
      PAYMENT_INVALID_AMOUNT: 'Virheellinen maksusumma.',
      PAYMENT_CARD_DECLINED: 'Korttisi hylättiin. Kokeile toista maksutapaa.',

      GIFT_CARD_NOT_FOUND: 'Lahjakorttia ei löytynyt tai se on virheellinen.',
      GIFT_CARD_INSUFFICIENT_BALANCE: 'Lahjakortin saldo ei riitä.',
      GIFT_CARD_INVALID_AMOUNT: 'Virheellinen lahjakortin summa.',

      PROMO_CODE_NOT_FOUND: 'Kampanjakoodia ei löydy tai se on virheellinen.',

      SESSION_BUNDLE_NOT_FOUND: 'Pakettia tai tilausta ei löytynyt.',
      SESSION_BUNDLE_NO_USES_REMAINING: 'Tässä paketissa ei ole jäljellä käyttökertoja.',
      SESSION_BUNDLE_ALREADY_PURCHASED: 'Sinulla on jo tämä paketti.',

      USER_NOT_FOUND: 'Käyttäjää ei löytynyt.',
      CLIENT_NOT_FOUND: 'Asiakasta ei löytynyt.',

      SERVICE_NOT_FOUND: 'Palvelua ei löytynyt.',
      SERVICE_UNAVAILABLE: 'Tämä palvelu ei ole tällä hetkellä saatavilla.',

      INVALID_REQUEST: 'Virheellinen pyyntö.',
      VALIDATION_ERROR: 'Tarkista syöttämäsi tiedot ja yritä uudelleen.',

      INTERNAL_ERROR: 'Tapahtui virhe. Yritä uudelleen.',
      EXTERNAL_API_ERROR: 'Palvelu on tilapäisesti poissa käytöstä. Yritä myöhemmin uudelleen.',
    },
  },

  // Date/Time formatting
  dateTime: {
    today: 'Tänään',
    tomorrow: 'Huomenna',
    weekdays: [
      'Sunnuntai',
      'Maanantai',
      'Tiistai',
      'Keskiviikko',
      'Torstai',
      'Perjantai',
      'Lauantai',
    ],
    months: [
      'Tammikuu',
      'Helmikuu',
      'Maaliskuu',
      'Huhtikuu',
      'Toukokuu',
      'Kesäkuu',
      'Heinäkuu',
      'Elokuu',
      'Syyskuu',
      'Lokakuu',
      'Marraskuu',
      'Joulukuu',
    ],
  },

  // Footer
  footer: {
    services: 'PALVELUT',
    infraredSauna: 'Infrapunasauna',
    coldPlunge: 'Kylmäallas',
    cryotherapy: 'Kylmähoito',
    redLightTherapy: 'Punavalohoito',
    cellumaFacialLightTherapy: 'Celluma-kasvojen valohoito',
    compressionMassage: 'Painehierontaa',
    gallery: 'GALLERIA',
    scienceAndStudies: 'TIEDE & TUTKIMUKSET',
    specialOffers: 'ERIKOISTARJOUKSET',
    pricing: 'HINNOITTELU',
    bookNow: 'VARAA NYT',
    copyright: '© {year} Fire and Ice. Kaikki oikeudet pidätetään.',
    checkGiftCardBalance: 'Tarkista lahjakortin saldo',
    privacyNotice: 'Tietosuojailmoitus',
    termsOfService: 'Käyttöehdot',
  },

  // Promotion
  promo: {
    code: 'Tarjouskoodi',
    have: 'Onko sinulla promokoodia?',
    applied: 'Kampanjakoodi käytetty',
    placeholder: 'Syötä tarjouskoodi',
    errors: {
      missingCode: 'Anna tarjouskoodi.',
      validationError: 'Kampanjakoodin vahvistamisessa tapahtui virhe.',
      invalidCode: 'Virheellinen tarjouskoodi',
    },
  },

  // Gift Card
  giftCard: {
    have: 'Onko sinulla lahjakortti?',
    applied: 'Lahjakortti käytetty',
    purchaseTitle: 'Osta digitaalinen Fire & Ice -lahjakortti',
    purchaseDescription:
      'Tämä lahjakortti on voimassa yhden vuoden ja sitä voi käyttää varausten, pakettien tai tilausten maksamiseen.',
    chooseAmount: 'Valitse summa',
    other: 'Muu',
    enterAmountPlaceholder: 'Syötä summa - vähintään 50 €',
    to: 'Saaja:',
    recipientName: 'Saajan nimi',
    recipientNamePlaceholder: 'Matti Meikäläinen',
    deliveryEmail: 'Toimituksen sähköpostiosoite',
    recipientEmailPlaceholder: 'matti@esimerkki.fi',
    from: 'Lähettäjä:',
    yourName: 'Nimesi',
    yourNamePlaceholder: 'Nimesi',
    yourEmail: 'Sähköpostisi',
    yourEmailPlaceholder: 'sinun@esimerkki.fi',
    yourPhone: 'Puhelinnumerosi',
    yourPhonePlaceholder: '+358 40 123 4567',
    personalMessage: 'Lisää henkilökohtainen viesti (valinnainen)',
    personalMessagePlaceholder: 'Kirjoita viestisi tähän...',
    characters: 'merkkiä',
    processing: 'Käsitellään...',
    proceedToPayment: 'Siirry maksuun',
    completePayment: 'Viimeistele maksu',
    minimumAmountError: 'Lahjakortin vähimmäissumma on 50 €',
    successMessage: 'Lahjakortti luotu onnistuneesti! Koodi: {{code}}',
    errorMessage: 'Lahjakortin luominen epäonnistui. Tarkista tietosi ja yritä uudelleen.',
    session: '{{count}} istunto',
    sessions: '{{count}} istuntoa',
    // Gift Card Balance Page
    balancePageTitle: 'Tarkista lahjakortin saldo',
    balancePageSubtitle: 'Syötä lahjakorttisi koodi alla nähdäksesi jäljellä olevan saldon.',
    codePlaceholder: 'XXXX-XXXX-XXXX',
    checkingBalance: 'Tarkistetaan...',
    checkBalance: 'Tarkista saldo',
    currentBalance: 'Nykyinen saldo:',
    invalidCode: 'Virheellinen lahjakortin koodi.',
    checkError: 'Tapahtui virhe. Yritä uudelleen.',
    enterCode: 'Syötä lahjakortin koodi.',
    cardDepleted: 'Tämä lahjakortti on täysin käytetty eikä ole enää voimassa.',
    successPageTitle: 'Lahjakortin osto onnistui!',
    successPageMessage: 'Lahjakorttisi on ostettu ja lähetetty vastaanottajalle.',
    detailsTitle: 'Oston tiedot',
    giftCardCode: 'Lahjakortin koodi',
    codeInfo: 'Vastaanottaja saa tämän koodin sähköpostitse.',
    amount: 'Summa',
    emailConfirmation: 'Vahvistusviesti on lähetetty osoitteeseen {{email}}.',
    emailSubject: 'Olet saanut lahjakortin käyttäjältä {{senderName}}!',
    emailHeading: 'Olet saanut lahjakortin!',
    emailIntro: 'lähetti sinulle lahjakortin!',
    amountLabel: 'Lahjakortin arvo',
    codeLabel: 'Lahjakorttisi koodi',
    messageLabel: 'Henkilökohtainen viesti',
    emailInstructions:
      'Käytä tätä koodia varaamalla seuraava Fire & Ice -istuntosi tai ostamalla paketteja ja tilauksia.',
    ctaText: 'Varaa nyt',
  },

  // Booking Upsell
  upsell: {
    message: 'Varaatko yksittäisiä käyntejä? Tilauksen tai paketin käyttö on edullisempaa.',
    linkText: 'Katso paketit ja jäsenyydet',
  },

  // Service Page
  servicePage: {
    bookNow: 'Varaa nyt',
    faqHeading: 'Usein kysytyt kysymykset',
  },

  // Booking Cart
  cart: {
    title: 'Varausvalintasi',
    empty: 'Valintasi on tyhjä.',
    addToCart: 'Varaa Aika',
    bookNow: 'Varaa nyt',
    addedToCart: 'Lisätty varausvalintoihisi!',
    bookingChanged: 'Varaus on muutettu',
    change: 'Muuta',
    remove: 'Poista',
    confirmRemove: 'Haluatko varmasti poistaa tämän varauksen korista?',
    total: 'Yhteensä',
    at: 'klo',
    addAnotherService: 'Lisää toinen palvelu',
    proceedToCheckout: 'Viimeistele Varaus',
    suggestedServices: 'Jatka hyvinvointimatkaa',
    suggestedServicesDescription:
      'Nämä palvelut ovat saatavilla heti viimeisen varauksesi jälkeen:',
    available: 'Saatavilla klo',
    bookingSelected: '{{count}} Varaus Valittu',
    bookingsSelected: '{{count}} Varausta Valittu',
    removeBookingTitle: 'Poista Varaus',
    confirmChange: 'Vahvista Muutos',
    credits: 'Krediittejä',
    participants: 'Osallistujat:',
    participantEmails: 'Osallistujien sähköpostit (valinnainen):',
    participantEmailPlaceholder: 'Osallistuja {{count}} sähköposti',
  },

  // Checkout Page
  checkout: {
    title: 'Kassa',
    bookingSummary: 'Varausten yhteenveto',
    orderSummary: 'Tilauksen yhteenveto',
    paymentDetails: 'Maksutiedot',
    securePaymentInfo: 'Maksusi käsitellään turvallisesti Stripen kautta.',
    cardDetails: 'Kortin tiedot',
    cardNumber: 'Kortin numero',
    expiryDate: 'Voimassaoloaika',
    cvc: 'CVC',
    processing: 'Käsitellään...',
    completeOrder: 'Viimeistele tilaus',
    payAmount: 'Maksa {{amount}}',
    cardElementError: 'Korttielementtiä ei löytynyt',
    paymentError: 'Maksu epäonnistui. Yritä uudelleen.',
    sessionBundleNotFound: 'Käyntikokonaisuutta ei löytynyt',
    packagePackNotFound: 'Pakettipakettia ei löydy',
    loadError: 'Paketin tietojen lataus epäonnistui',
    enterGiftCardCode: 'Syötä lahjakortin koodi',
    giftCardNoBalance: 'Tällä lahjakortilla ei ole saldoa',
    invalidCode: 'Virheellinen koodi',
    monthlySubscription: 'Kuukausitilaus',
    bulkSessionBundle: 'Käyntikokonaisuus',
    sessions: 'käyntiä',
    subtotal: 'Välisumma',
    promotionDiscount: 'Kampanja-alennus',
    promotionCodeDiscount: 'Alennuskoodi alennus',
    giftCardDiscount: 'Lahjakortin alennus',
    total: 'Yhteensä',
    enterCode: 'Syötä koodi',
    apply: 'Käytä',
    remove: 'Poista',
    customerInfo: 'Asiakastiedot',
    name: 'Nimi',
    email: 'Sähköposti',
    unavailable: 'Ei saatavilla',
    unavailableItemsMessage: 'Jotkut varaukset eivät ole enää saatavilla. Poista ne jatkaaksesi.',
    removeUnavailable: 'Poista Ei-saatavilla Olevat Varaukset',
    bookingInfo: 'Varauksesi vahvistetaan välittömästi. Voit hallita niitä tilisivultasi.',
    confirmBookings: 'Vahvista Varaukset',
    processingOrder: 'Käsitellään tilausta',
    pleaseWait: 'Odota, kun vahvistamme ostoksesi...',
  },

  // Purchase Confirmation Page
  confirmation: {
    title: 'Ostovahvistus',
    successTitle: 'Kiitos ostoksestasi!',
    successMessage: 'Tilauksesi on valmis.',
    noData: 'Tilaustietoja ei saatavilla',
    orderDetails: 'Tilauksen tiedot',
    sessionBundle: 'Käyntikokonaisuus',
    subscription: 'Tilaus',
    amountPaid: 'Maksettu summa',
    paymentMethod: 'Maksutapa',
    giftCardOnly: 'Lahjakortti',
    cardAndGiftCard: 'Luottokortti ja lahjakortti',
    whatNext: 'Mitä seuraavaksi?',
    confirmationEmail: 'Saat pian vahvistussähköpostin ostoksesi tiedoista.',
    bookSession: 'Varaa käynti',
    goToAccount: 'Siirry tililleni',
    contractError: 'Pakettisi aktivoinnissa ilmeni ongelma. Ole hyvä ja ota yhteyttä tukeen.',
    creatingContract: 'Viimeistellään ostosta, odota hetki...',
  },

  // Newsletter
  newsletter: {
    title: 'Pysy ajan tasalla',
    subtitle: 'Tilaa uutiskirjeemme saadaksesi uusimmat päivitykset ja hyvinvintivinkkejä.',
    firstNamePlaceholder: 'Etunimi',
    lastNamePlaceholder: 'Sukunimi',
    emailPlaceholder: 'Syötä sähköpostiosoitteesi',
    subscribing: 'Tilataan...',
    subscribe: 'Tilaa',
    successMessage: 'Kiitos tilauksesta!',
    errorMessage: 'Jotain meni vikaan. Yritä uudelleen.',
  },

  // Console messages (for debugging)
  console: {
    errors: {
      fetchingBookings: 'Virhe varausten hakemisessa:',
      fetchingUserSessionBundles: 'Virhe käyttäjän pakettien hakemisessa:',
      cancellingBooking: 'Virhe varauksen peruuttamisessa:',
      fetchingSessionBundles: 'Virhe käyntikokonaisuuksien hakemisessa:',
      fetchingServices: 'Virhe palveluiden hakemisessa:',
      completingRegistration: 'Virhe rekisteröinnin viimeistelyssä:',
      creatingBooking: 'Virhe varauksen luomisessa:',
      fetchingService: 'Virhe palvelun hakemisessa:',
      fetchingAvailability: 'Virhe saatavuuden hakemisessa:',
      reschedulingBooking: 'Virhe varauksen siirtämisessä:',
      fetchingGiftCardBalance: 'Virhe lahjakortin saldon hakemisessa:',
      giftCardRedemptionFailed: 'Lahjakortin lunastus epäonnistui:',
      creatingGiftCard: 'Virhe lahjakortin luomisessa:',
      authCallbackError: 'Auth0-takaisinkutsun virhe:',
      authErrorDetails: 'Auth0-virheen tiedot:',
    },
  },

  // Coupon Codes
  coupon: {
    title: 'Kuponkikoodi',
    haveCoupon: 'Onko sinulla kuponkikoodi?',
    placeholder: 'Syötä kuponkikoodi',
    applied: 'Kuponki käytetty!',
    sessionsIncluded: '{{count}} istuntoa sisältyy',
    sessionsAlreadyUsed: '{{count}} istuntoa jo käytetty',
    bookAnotherLater: 'Varaa toinen istunto myöhemmin käyttääksesi ilmaisen istuntosi!',
    youSave: 'Säästät',
    cancellationPolicyTitle: 'Linkitettyjen varausten käytäntö',
    cancellationPolicyText:
      'Molemmat istunnot on peruutettava yhdessä. Jos peruutat yhden istunnon, molemmat istunnot peruutetaan ja kuponki palautetaan tulevaa käyttöä varten.',
    // Coupon pair cancellation
    sessionBadge: 'Kuponki',
    cancelPairTitle: 'Peruuta kuponki-istunnot',
    linkedBookingNotice: 'Linkitetty kuponkivaraus',
    pairCancellationExplanation:
      'Tämä varaus kuuluu kuponkipariin. Molemmat istunnot on peruutettava yhdessä täyden hyvityksen saamiseksi.',
    pairCancellationConfirm:
      'Peruuttaminen peruuttaa molemmat kuponki-istunnot ja palauttaa {{amount}}. Kuponkikoodisi palautetaan tulevaa käyttöä varten.',
    linkedSessions: 'Peruutettavat linkitetyt istunnot:',
    cancelBothSessions: 'Peruuta molemmat istunnot',
    pairCancellationSuccess:
      'Molemmat kuponki-istunnot on peruutettu onnistuneesti. {{amount}} palautettu. Kuponki palautettu uudelleenkäyttöön.',
    errors: {
      missingCode: 'Anna kuponkikoodi.',
      missingEmail: 'Kupongin vahvistamiseen tarvitaan sähköpostiosoite.',
      invalidCode: 'Tämä kuponkikoodi on virheellinen tai vanhentunut.',
      alreadyUsed: 'Tämä kuponkikoodi on jo käytetty kokonaan.',
      noSessions: 'Lisää vähintään yksi istunto ostoskoriin.',
      validationError: 'Kuponkikoodin vahvistamisessa tapahtui virhe.',
      sessionAlreadyUsed:
        'Peruuttaminen ei ole mahdollista: yksi tai useampi linkitetty istunto on jo käytetty. Voit ehkä silti siirtää varauksen 24 tunnin sisällä tapaamisesta.',
      cannotCancel: 'Näiden istuntojen peruuttaminen ei ole tällä hetkellä mahdollista.',
    },
    success: 'Kuponki käytetty! Säästät {{discount}}.',
  },

  // Gallery
  gallery: {
    title: 'Galleria',
    subtitle: 'Tutustu wellness-studiomme hetkiin',
    pageTitle: 'Galleria',
    pageDescription: 'Selaa Fire & Ice -wellness-kokemusten galleriaa Tallinnassa.',
    viewImage: 'Näytä kuva',
    lightboxLabel: 'Kuvankatseluikkuna',
    previousImage: 'Edellinen kuva',
    nextImage: 'Seuraava kuva',
    loadError: 'Gallerian lataus epäonnistui',
    noImages: 'Kuvia ei saatavilla',
  },

  // SEO
  seo: {
    defaultTitle: 'Fire & Ice - Hyvinvointi ja Palautuminen',
    defaultDescription:
      'Koe paras hyvinvointimatka Fire & Icen kanssa. Ensiluokkaiset kontrastiterapiapalvelut, mukaan lukien sauna, kylmäallas ja paljon muuta Tallinnassa.',
    homeDescription:
      'Fire and Ice on paikka, jossa voit rentoutua ja antaa meidän huolehtia sinusta. Kasvo- ja vartalohoidot, jotka tukevat sekä kauneutta että terveyttä. Varaa aikasi tänään.',
    privacyDescription:
      'Tutustu tietosuojakäytäntöömme saadaksesi selkeän yleiskuvan henkilötietojen keräämisestä, käytöstä ja suojaamisesta. Lue lisää.',
    bookDescription:
      'Varaa Fire and Ice -hyvinvointihoito sinulle sopivaan aikaan. Valitse palvelu ja aika nauttiaksesi uuden aikakauden hyvinvointikokemuksesta. Odotamme sinua!',
    termsDescription:
      'Fire and Ice -käyttöehdot selittävät palveluiden käytön säännöt, käyttäjän oikeudet ja vastuut. Suosittelemme ehtojen lukemista ennen varausta.',
    pricingDescription:
      'Katso Fire and Ice -hinnasto ja pakettivaihtoehdot. Löydä itsellesi sopiva ratkaisu ja varaa istunto helposti.',
    promotionsDescription:
      'Tutustu Fire and Ice -erikoistarjouksiin ja kampanjoihin. Hyödynnä tilaisuus kokeilla hyvinvointihoitoja edullisemmin ja varaa aika helposti.',
    contactDescription:
      'Löydä Fire and Ice -yhteystiedot ja sijainti. Jos sinulla on kysyttävää palveluista tai varauksesta, ota meihin yhteyttä.',
    scienceStudiesDescription:
      'Palvelumme perustuvat tieteelliseen tutkimukseen ja näyttöön perustuviin menetelmiin. Lue lisää siitä, miten ne auttavat sinua palautumaan ja voimaan paremmin.',
    checkBalanceDescription:
      'Syötä tiedot ja näe heti, paljonko Fire and Ice -lahjakortillasi on saldoa. Yksinkertaista, nopeaa ja kätevää!',
    galleryDescription:
      'Selaa wellness-kokemustemme galleriaa Fire & Ice -keskuksessa. Katso saunamme, kylmäaltaamme ja palautumismahdollisuutemme Tallinnassa.',
    services: {
      'infrared-sauna':
        'Infrapunasauna auttaa rentoutumaan, tukee palautumista ja parantaa hyvinvointia. Nauti rauhallisesta ympäristöstä ja varaa istunto helposti verkossa.',
      'compression-massage':
        'Kompressiohieronta parantaa verenkiertoa ja tukee palautumista. Rentoudu, palaudu ja varaa istunto helposti verkossa.',
      'contrast-therapy':
        'Kontrastiterapia yhdistää kylmän ja kuuman vaikutukset, auttaen kehoa palautumaan ja parantaen hyvinvointia. Varaa istunto helposti verkossa.',
      'celluma-facial-light-therapy':
        'Celluma LED-valohoito kasvoille auttaa parantamaan ihon rakennetta, vähentämään tulehdusta ja tukemaan kollageenin tuotantoa. Varaa istunto.',
      'cryotherapy-full-body':
        'Koko vartalon kylmähoito tarjoaa intensiivisen kylmäkokemuksen, joka tukee palautumista ja parantaa hyvinvointia. Varaa istunto helposti verkossa.',
      'cold-plunge':
        'Kylmävesiallas tarjoaa virkistävän kokemuksen, joka tukee palautumista ja parantaa hyvinvointia. Koe kylmän vaikutus ja varaa istunto helposti.',
      'red-light-therapy':
        'Punavalohoito auttaa kehoa palautumaan ja lisää hyvinvointia. Ota aikaa itsellesi ja varaa istunto helposti verkossa.',
    },
  },

  // Birthday Picker
  birthdayPicker: {
    selectYear: 'Valitse vuosi',
    selectMonth: 'Valitse kuukausi',
    selectDay: 'Valitse päivä',
    placeholder: 'pp/kk/vvvv',
  },
};
